import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Check } from "lucide-react";

const SHOPPING = [
  { cat: "Proteins", items: ["Chicken", "Eggs", "Canned tuna / salmon", "Frozen fish", "Lean beef", "Greek yoghurt", "Beans / lentils"] },
  { cat: "Carbohydrates", items: ["Potatoes", "Sweet potato", "Rice", "Rolled oats", "Wholegrain bread / wraps", "Wholemeal pasta"] },
  { cat: "Vegetables", items: ["Frozen broccoli", "Stir-fry vegetables", "Spinach", "Lettuce", "Tomatoes", "Carrots", "Capsicum", "Onions"] },
  { cat: "Fruit", items: ["Bananas", "Apples", "Oranges", "Berries", "Seasonal fruit"] },
  { cat: "Healthy Fats / Flavour", items: ["Olive oil", "Avocado", "Nuts / seeds", "Herbs, spices", "Lemon / lime", "Salsa", "Greek yoghurt"] },
];

const KEY = "ba30_shopping_check";

export default function EatShopping() {
  const [checked, setChecked] = useState({});

  useEffect(() => {
    try { setChecked(JSON.parse(localStorage.getItem(KEY) || "{}")); } catch { /* noop */ }
  }, []);

  const toggle = (item) => {
    setChecked((prev) => {
      const next = { ...prev, [item]: !prev[item] };
      localStorage.setItem(KEY, JSON.stringify(next));
      return next;
    });
  };

  const clearAll = () => { setChecked({}); localStorage.removeItem(KEY); };

  return (
    <div className="space-y-8" data-testid="eat-shopping-page">
      <div>
        <Link to="/app/eat" className="text-xs uppercase tracking-widest text-muted-foreground inline-flex items-center gap-1 hover:text-primary">
          <ChevronLeft size={14} /> Eat
        </Link>
        <div className="label-eyebrow mt-3">Shopping Base</div>
        <h1 className="wordmark mt-2 text-4xl md:text-5xl uppercase">The 10K30 Family Base.</h1>
        <p className="mt-2 text-muted-foreground max-w-xl">Open this while you shop. Tick items as they go in the trolley. Your progress is saved on this device.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-3">
        {SHOPPING.map((s) => (
          <div key={s.cat} className="bg-card border border-border rounded-lg p-5" data-testid={`shopping-${s.cat.toLowerCase().replace(/[^a-z]/g, "")}`}>
            <div className="label-eyebrow">{s.cat}</div>
            <ul className="mt-4 space-y-1">
              {s.items.map((it) => {
                const on = !!checked[it];
                return (
                  <li key={it}>
                    <button onClick={() => toggle(it)}
                      className={`w-full flex items-center gap-3 text-left rounded-md px-3 py-2 text-sm transition-colors ${on ? "bg-primary/10 text-foreground/60 line-through" : "hover:bg-muted"}`}
                      data-testid={`shopping-item-${it.toLowerCase().replace(/[^a-z]/g, "")}`}>
                      <span className={`w-5 h-5 rounded-md border-2 flex items-center justify-center ${on ? "bg-primary border-primary text-primary-foreground" : "border-foreground/40"}`}>
                        {on && <Check size={12} strokeWidth={3} />}
                      </span>
                      <span>{it}</span>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>

      <div className="bg-foreground text-background rounded-lg p-6 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-background/80 max-w-xl">Frozen vegetables, canned beans, canned fish and seasonal fruit are practical whole-food choices that keep the system sustainable and affordable.</p>
        <button onClick={clearAll} className="btn-secondary btn-sm !border-background/80 !text-background hover:!bg-background hover:!text-foreground" data-testid="shopping-clear">Clear list</button>
      </div>
    </div>
  );
}
